import { bool, string, shape, arrayOf, func, oneOf, number } from 'prop-types';

// Container Desktop
export const containerDesktopPropTypes = {
  extraInfo: arrayOf(
    shape({
      icon: shape({ id: string, color: string }),
      subtitles: arrayOf(shape({ text: string })),
      title: shape({ text: string }),
      action_dto: shape({
        label: shape({
          text: string,
        }),
        track: shape({}),
      }),
    }),
  ),
  phoneLink: shape({
    label: shape({
      text: string,
    }),
    track: shape({}),
    action_type: string,
  }),
  header: shape({
    text: string,
    color: string,
    font_size: string,
    font_family: string,
  }).isRequired,
  sellerName: shape({
    title: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
    subtitle: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
    user_status_icon: shape({
      id: string,
    }),
    logo: shape({
      alt: string,
      url: shape({
        src: string,
      }),
      width: number,
      height: number,
    }),
    href: string,
  }).isRequired,
  sellerStatus: shape({
    rank: number,
    is_thermometer_large: bool,
    seller_status_info: shape({
      title: shape({
        text: string,
        color: string,
        font_size: string,
        font_family: string,
      }),
      subtitle: shape({
        text: string,
        color: string,
        font_size: string,
        font_family: string,
      }),
    }),
    thermometer_id: string,
  }),
  userStatusTooltip: shape({
    body: shape({
      text: string,
      color: string,
    }),
    closeable: bool,
    thumbnail: shape({
      id: string,
    }),
  }),
  fetchContactInfo: func,
  statusInfoVisProps: shape({
    itemId: string,
    isFetching: bool,
  }),
  containerActions: arrayOf({
    actions: arrayOf(
      shape({
        label: shape({
          text: string.isRequired,
          color: string,
        }).isRequired,
        type: string.isRequired,
        target: string,
        track: shape({}),
      }),
    ).isRequired,
  }),
  recaptchaPublicKey: string,
  recaptchaSiteKey: string,
  messages: shape({
    text: string,
    type: oneOf(['success', 'error']),
    key: number,
  }),
  focus: bool,
  doContactAction: arrayOf(
    shape({
      origin: string,
    }),
  ),
  redirectToLogin: func,
  onScrollComponent: func,
  featureName: string.isRequired,
  bottomExtraInfo: arrayOf(
    shape({
      icon: shape({
        id: string,
        color: string,
        size: string,
      }),
      title: shape({
        text: string,
        color: string,
        font_size: string,
        font_family: string,
      }),
      subtitles: arrayOf(
        shape({
          text: string,
          color: string,
          font_size: string,
          font_family: string,
        }),
      ),
    }),
  ),
  linkLabel: shape({
    target: string,
    html_target: string,
    action_type: string,
    label: shape({
      text: string,
      color: string,
      font_size: string,
      font_family: string,
    }),
    track: shape({
      analytics_event: {
        page: string,
        action: string,
        category: string,
        label: string,
      },
    }),
  }),
  withBottomSeparatorBar: bool,
  withBottomLinkLabel: bool,
  withTagsSeparatorBar: bool,
  thermometer: shape({
    rank: number,
    info: arrayOf(
      shape({
        icon: shape({ id: string }),
        subtitle: string,
        title: string,
      }),
    ),
    defaultInfo: shape({
      subtitle: shape({
        color: string,
        text: string,
      }),
      title: shape({
        color: string,
        text: string,
      }),
    }),
  }),
  tagsReputationAlign: string,
  layout: string.isRequired,
  className: string,
};
